/**
 * Emoji configuration for Flock chat reactions.
 *
 * - QUICK_REACT_EMOJIS: 10 emojis shown in the quick-react bar
 * - FAITH_CATEGORY_EMOJIS: curated faith emojis for the first picker tab
 * - EMOJI_BLOCKLIST: emojis removed from the full picker
 * - LEGACY_REACTION_MAP: maps old string keys to emoji characters
 */

// 10 quick-react emojis shown when user taps "React" on a message
export const QUICK_REACT_EMOJIS = [
  '\u{1F64F}',        // prayer hands
  '\u{2764}\u{FE0F}', // red heart
  '\u{1F64C}',        // raised hands
  '\u{2728}',         // sparkles
  '\u{1F44F}',        // clap
  '\u{1F60A}',        // smile
  '\u{1F525}',        // fire
  '\u{1F602}',        // laughing
  '\u{1F44D}',        // thumbs up
  '\u{1F4AA}',        // flexed biceps
] as const;

// Faith category - shown as first tab in full emoji picker
export const FAITH_CATEGORY_EMOJIS = [
  '\u{1F64F}',           // prayer hands
  '\u{271D}\u{FE0F}',   // latin cross
  '\u{1F607}',           // smiling face with halo
  '\u{1F54A}\u{FE0F}',  // dove
  '\u{1F64C}',           // raised hands
  '\u{1F525}',           // fire
  '\u{2764}\u{FE0F}',   // red heart
  '\u{1F932}',           // palms up together
  '\u{26EA}',            // church
  '\u{1F47C}',           // baby angel
  '\u{1F6D0}',           // place of worship
  '\u{1F4FF}',           // prayer beads
  '\u{1F56F}\u{FE0F}',  // candle
  '\u{1F647}',           // person bowing
  '\u{1F9CE}',           // person kneeling
  '\u{1FAF6}',           // heart hands
  '\u{1F492}',           // wedding chapel
  '\u{2626}\u{FE0F}',   // orthodox cross
  '\u{1F4A7}',           // water droplet
  '\u{2B50}',            // star
  '\u{1F305}',           // sunrise
  '\u{1FAC2}',           // people hugging
  '\u{1F4AA}',           // flexed biceps
];

// Legacy reaction key -> emoji character map.
// Old messages stored reactions as string keys (e.g., "prayer_hands").
// New messages store the emoji character directly.
// ReactionDisplay uses this to render old reactions correctly.
export const LEGACY_REACTION_MAP: Record<string, string> = {
  prayer_hands: '\u{1F64F}',
  heart: '\u{2764}\u{FE0F}',
  raised_hands: '\u{1F64C}',
  sparkles: '\u{2728}',
  clap: '\u{1F44F}',
  smile: '\u{1F60A}',
};

// Emoji names to remove from the full picker.
// Names must match the `name` field from rn-emoji-keyboard exactly (spaces, not underscores).
export const EMOJI_BLOCKLIST = new Set([
  // Rude gestures
  'middle finger',
  'OK hand',
  'backhand index pointing left',
  'backhand index pointing right',

  // Alcohol & drugs
  'beer mug',
  'clinking beer mugs',
  'wine glass',
  'cocktail glass',
  'tumbler glass',
  'sake',
  'bottle with popping cork',
  'tropical drink',
  'cigarette',
  'pill',
  'syringe',

  // Sexual / suggestive
  'eggplant',
  'peach',
  'banana',
  'cucumber',
  'sweat droplets',
  'dashing away',
  'water wave',
  'face with tongue',
  'squinting face with tongue',
  'tongue',
  'mouth',
  'kiss mark',
  'hot face',
  'bikini',

  // Demonic / dark
  'smiling face with horns',
  'angry face with horns',
  'skull',
  'skull and crossbones',
  'ogre',
  'goblin',

  // Non-Christian religious / zodiac symbols
  'om',
  'yin yang',
  'star and crescent',
  'Aries',
  'Taurus',
  'Gemini',
  'Cancer',
  'Leo',
  'Virgo',
  'Libra',
  'Scorpio',
  'Sagittarius',
  'Capricorn',
  'Aquarius',
  'Pisces',
  'Ophiuchus',

  // Gender symbols
  'female sign',
  'male sign',

  // Flags
  'rainbow flag',

  // Misc
  'pile of poo',
  'alien monster',
]);
